import GeneralHelper from "./generalHelper"

export default class PatternBuilderConfig  {

  constructor () {
    if (!PatternBuilderConfig.instance) {
      PatternBuilderConfig.instance = {
        SHOPPER_COUNTRY : "USA",
        STAHLS_API_BASE : "https://api.stahls.com/",
        //STAHLS_API_BASE : "https://api.stahls.com/",
        LOGGED_IN : true,
        SHOPPER_ID : "",
        GROUPID : "",
        RULERBAR_PATH : "RulerBar.js",
        WIZARD_ID : "PatternBuilder",

        ITEM_CLASSES : {
            "GROUPED": [ "010180","010181" ],
            "SINGLE":[ "010185" ]
          },

        MAIN_CONTAINER :  "PatternBuilderContainer",
        WIZARD_CONTAINER : "#WIZARD.PATTERN-BUILDER .WIZARD-SECTIONS-CONTAINER",
        CUSTOMER_HASH : "",
        TESTING : true ,

      //SERVICE_BASE :  "CXCORE-CADCUT-PATTERNS.AZUREWEBSITES.NET/",
        SERVICE_BASE :  "cadworx-master-edge.azurewebsites.net/",
        //SERVICE_BASE  :  "localhost/CxCore/",
        SESSIONID  :  "fb1a2921-b12f-4468-a3b9-de7c53c82da8",
        CONFIG  :  "SidPatterns_Stage",
        SUPERUSER  :  false,
        CDN :  "cadworx-master-edge.azurewebsites.net/cdn/",
        //CDN  :  "localhost/CxCore/cdn/",
        CLIENTTOKEN  :  "883BA8933D0C40E4A18F23BF037E3466",
        SERVERTOKEN  :  "8E5A26B8FCA04D1D8171FF77E59332E2",
        SETNAME  :  "/PUBLIC/DESIGNER",
        SETNAMEPRODUCTION  :  "/PRIVATE/PRODUCTION/",

        FAVORITESSECTION :  'SELECT-FAVORITES-SECTION',

        FIELDNAME : "",
        STEPINDEX : "",
        EDITPATTERNID : "",

        SELECT_FAVORITES_SECTION_SELECTOR : "SELECT-FAVORITES-SECTION",
        PATTERN_BUILDER_MAINTAINANCE_SELECTOR : "PATTERN-BUILDER-MAINTENANCE",
        MAIN_TITLE : "MAINTITLE",
        MODALERROR: false,
        DEFAULTPATTERNID: "",
        DEFAULTCATEGORY: ""
      }
    }
    // Initialize object
    return PatternBuilderConfig.instance
  }
};